import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

// CSS Imports
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

// Χρησιμοποιούμε μόνο το Drupal object (όχι jQuery ή το παλιό once library)
((Drupal) => {
  Drupal.behaviors.customSwiper = {
    attach: (context) => {

      // Native "once" αντικατάσταση (Drupal 9.4+)
      // Αν το project σου είναι παλιότερο, μπορείς να χρησιμοποιήσεις ένα απλό dataset check
      const swiperElements = context.querySelectorAll('.swiper:not([data-swiper-initialized])');

      if (swiperElements.length === 0) return;

      const initSwiperInstance = (el) => {
        // Μαρκάρουμε το στοιχείο ως initialized
        el.setAttribute('data-swiper-initialized', 'true');

        const modules = [Navigation, Autoplay];

        // 1. Podcasts Carousel
        if (el.classList.contains('podcasts-carousel')) {
          const podcastsCarousel = new Swiper(el, {
            modules: modules,
            slidesPerView: 1.2,
            spaceBetween: 10,
            breakpoints: { 1024: { slidesPerView: 1 } },
          });

          const container = el.closest('section');
          const slidePrev = container?.querySelector(".podcast-button-prev");
          const slideNext = container?.querySelector(".podcast-button-next");

          if (slidePrev && slideNext) {
            // Event listeners χωρίς jQuery
            slidePrev.addEventListener("click", (e) => {
              e.preventDefault();
              podcastsCarousel.slidePrev();
            });
            slideNext.addEventListener("click", (e) => {
              e.preventDefault();
              podcastsCarousel.slideNext();
            });
          }
        }

        // 2. Portrait Swiper
        if (el.classList.contains('portraitSwiper')) {
          new Swiper(el, {
            modules: modules,
            slidesPerView: 1.2,
            spaceBetween: 10,
            autoplay: { delay: 3000, disableOnInteraction: false },
            breakpoints: {
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1440: { slidesPerView: 4 },
            },
          });
        }

        // 3. Events Swiper
        if (el.classList.contains('eventsSwiper')) {
          new Swiper(el, {
            modules: modules,
            slidesPerView: 1.2,
            spaceBetween: 10,
            autoplay: { delay: 4000 },
            breakpoints: {
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4, spaceBetween: 16 },
            },
          });
        }
      };

      // Intersection Observer
      const swiperObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            initSwiperInstance(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '200px 0px',
        threshold: 0.01
      });

      swiperElements.forEach((el) => {
        swiperObserver.observe(el);
      });
    }
  };
})(Drupal);
